const systemFields = new Set(['rowType']);

// Filter a full field catalog to the user-visible set for table rendering.
//
// Mirrors the server-side logic originally in api/ai/tools/contract.js — kept in
// the frontend because `display` is a Table-only rendering concern that should
// not narrow the LLM's field metadata or other view types (pivot, schedule).
//
// Rules:
// 1. Empty/unset display → visible-by-default fields only.
// 2. Display list → listed fields in display order, marked visible.
// 3. System fields (e.g. rowType) are always included for render styling.
// 4. When any displayed field is `grouped`, all grouped fields are force-included
//    so implied groupings (e.g. project → client) render together.
export function applyDisplay(fields, display) {
  if (!Array.isArray(display) || display.length === 0) {
    return fields.filter((f) => f.visible !== false);
  }

  const displaySet = new Set(display);

  const displayed = display
    .map((key) => fields.find((f) => f.key === key))
    .filter(Boolean)
    .map((f) => ({ ...f, visible: true }));

  const hasGroupedField = displayed.some((f) => f.grouped);
  for (const f of fields) {
    if (displaySet.has(f.key)) continue;
    if (systemFields.has(f.key) || (hasGroupedField && f.grouped)) {
      displayed.push(f);
    }
  }

  return displayed;
}
